const config = {
  API_URL: process.env.REACT_APP_API_URL ?? 'https://dev-store.nebumaga.com',
}

export default config
